import Files from "src/containers/Files";

export default Files;
